import React from 'react';

function Dashboard() {
	return <div className='d-flex justify-content-center align-center w-100 mt-5 fs-1 fw-bold'>Babbusiya Dashboard</div>;
}

export default Dashboard;
